import { Pipe, PipeTransform } from '@angular/core';

import { Student } from '../types/tt-my-class.types';

@Pipe({ name: 'showCheckIns' })
export class ShowCheckInsPipe implements PipeTransform {
  transform(
    isCheckInEnabled: boolean,
    showCheckIn: boolean,
    student: Student,
    pastCheckIns: Array<{
      title: string;
      name: string;
      checkedInAt: Date;
    }>,
  ): boolean {
    // even if we have no past check ins, if the user originates from a flex time list we want to show muted check in pill
    const isFlextimeStudent = student?.listTypeOrigin === 'flextime';
    return isCheckInEnabled && showCheckIn && (pastCheckIns?.length > 0 || isFlextimeStudent);
  }
}
